// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3587":"64f488716308ce5a","9651":"9be695e992890e60"}[chunkId] + ".js";
};